<template>
  <div class="product-detail">
    <div class="product-detail-wrap" v-loading="loading">
      <div class="container">
        <div class="product-detail-panel" v-if="detail.Id">
          <h2 class="detail-title">{{ detail.Title }}</h2>
          <p class="detail-meta">
            <span>来源：湖南中云图</span>
          </p>
          <p class="detail-summary" v-if="detail.Summary">{{ detail.Summary }}</p>
          <div class="rich-body" v-html="detail.Content"></div>
          <div class="detail-actions">
            <router-link to="/product" class="back-link">&lt; 返回产品中心</router-link>
          </div>
        </div>
        <div class="empty-tip" v-else-if="!loading">未找到该产品</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      detail: {}
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    "$route.params.id"() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      const id = this.$route.params.id;
      this.loading = true;
      this.$http
        .get(`Product/${id}`)
        .then(response => {
          this.detail = response.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.detail = {};
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.product-detail {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.product-detail-wrap {
  padding: 28px 0 0;
}

.product-detail-panel {
  background: #fff;
  border: 1px solid $color-border;
  padding: 36px 40px;
  max-width: 1000px;
  margin: 0 auto;

  .detail-title {
    margin: 0;
    font-size: 26px;
    color: $color-text;
    font-weight: 600;
    line-height: 1.4;
    border-left: 4px solid $color-accent;
    padding-left: 14px;
  }

  .detail-meta {
    margin: 8px 0 16px;
    color: $color-text-3;
    font-size: 13px;
    border-bottom: 1px dashed $color-border;
    padding-bottom: 14px;
  }

  .detail-summary {
    margin: 0 0 20px;
    color: $color-text-2;
    font-size: 14px;
    line-height: 1.8;
    background: $color-bg-2;
    border-left: 3px solid $color-primary;
    padding: 12px 16px;
  }

  .rich-body {
    margin-top: 18px;
    color: $color-text;
    font-size: 14px;
    line-height: 1.85;

    & ::v-deep h2 {
      margin: 24px 0 10px;
      color: $color-text;
      font-size: 20px;
      font-weight: 600;
    }

    & ::v-deep h3 {
      margin: 18px 0 8px;
      color: $color-primary;
      font-size: 17px;
    }

    & ::v-deep img {
      display: block;
      max-width: 100%;
      height: auto;
      margin: 14px auto;
      border: 1px solid $color-border;
    }

    & ::v-deep p {
      margin: 0 0 12px;
    }
  }

  .detail-actions {
    margin-top: 32px;
    padding-top: 18px;
    border-top: 1px solid $color-border;
  }

  .back-link {
    color: $color-accent;
    text-decoration: none;
    font-size: 14px;

    &:hover { text-decoration: underline; }
  }
}

.empty-tip {
  text-align: center;
  color: $color-text-3;
  padding: 60px 0;
}

@media (max-width: 720px) {
  .product-detail-panel { padding: 22px 18px; }
  .detail-title { font-size: 20px; }
}
</style>
